import styled from '@emotion/styled';
import { Selection } from 'src/domains/sportsbook/webview/components/Selection/Selection';

export const SelectionWrapper = styled(Selection, { label: 'SelectionWrapper' })`
    align-self: stretch;
`;

export const CellRunner = styled('div', { label: 'CellRunner' })`
    align-items: center;
    align-self: stretch;
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 auto;
    gap: 8px;
    justify-content: start;
    padding: 8px 12px;
`;
